import axios from "axios";
import { config } from "../../config";
import { SubledgerEndpoints } from "../../SubledgerEndpoints";
import { AuthorizationToken } from "../../services/RequestHelpers";
import { IAttachment } from "../../schemas/SLAttachment";
import { ISLEntryActionResponse } from "../../schemas/ISLEntryResponse";
import { ISlEntryAttachmentActionRequest } from "../../schemas/SLAttachmentPostBody";
import { ISlBatchAttachmentActionRequest } from "../../schemas/SLBatchAttachmentPostBody";
import { actionsClientCalls } from "../SLActionsManager/SLActionManagerRequests";
import { IUserProviderState } from "../../contexts/UserContext";

export interface IPostAttachmentResponse {
  readonly blobName: string;
  readonly inputFileName: string;
  readonly fileStorageUri: string;
  readonly fileSize: number;
  readonly uploadedOn: string;
}

export async function postAttachment(
  file: File,
  SelectedSlEntryIds: number[],
  getTokenFn: IUserProviderState["accessToken"]
): Promise<IPostAttachmentResponse> {
  const postAttachmentUrl = config.get("attachmentUrl") + SubledgerEndpoints.attachmentPath;
  const formData = new FormData();
  formData.append("files[]", file);
  formData.append("SelectedSlEntryIds[]", JSON.stringify(SelectedSlEntryIds));
  const Authorization = await AuthorizationToken(getTokenFn);
  const result = await axios.post(postAttachmentUrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization
    },
    timeout: 5000
  });
  return result.data as IPostAttachmentResponse;
}

export async function patchAttachments(
  attachments: IAttachment[],
  SelectedSlEntryIds: number[],
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ISLEntryActionResponse[]> {
  const attachmentUrl =
    config.get("subledgerUrl") + SubledgerEndpoints.slActions + SubledgerEndpoints.slActionsAddAttachment;
  const payload: ISlEntryAttachmentActionRequest = {
    attachments,
    SelectedSlEntryIds
  };
  const responseForEntriesAction: ISLEntryActionResponse[] = await actionsClientCalls(
    payload,
    attachmentUrl,
    getTokenFn
  );
  return responseForEntriesAction;
}

export async function patchBatchAttachments(
  attachments: IAttachment[],
  SelectedSlBatchRefGuids: string[],
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ISLEntryActionResponse[]> {
  const attachmentUrl =
    config.get("subledgerUrl") + SubledgerEndpoints.slBatchActions + SubledgerEndpoints.slUpdateBatchAttachment;
  const payload: ISlBatchAttachmentActionRequest = {
    attachments,
    SelectedSlBatchRefGuids
  };
  const responseForEntriesAction: ISLEntryActionResponse[] = await actionsClientCalls(
    payload,
    attachmentUrl,
    getTokenFn
  );
  return responseForEntriesAction;
}
